
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ConsultationContactForm from '@/components/ConsultationContactForm';
import { Button } from '@/components/ui/button';
import { Users } from 'lucide-react';
import { Link } from 'react-router-dom';

const SpecialtyServices: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <section className="bg-itmgmt-dark-blue text-white py-16 md:py-24">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="heading-xl mb-6">
                Specialty Services
              </h1>
              <p className="text-xl mb-8 text-gray-300">
                Unique technology solutions tailored to specific business requirements 
                and specialized industry needs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild className="button-primary">
                  <Link to="/book?service=specialty">Book a Consultation</Link>
                </Button>
              </div>
            </div>
            <div className="hidden lg:flex justify-center">
              <div className="bg-itmgmt-medium-blue bg-opacity-20 p-8 rounded-full">
                <Users size={120} className="text-itmgmt-bright-blue" />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="section-padding bg-white">
        <div className="container-wide">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Specialized Solutions</h2>
              <p className="text-lg text-gray-600 mb-8">
                Our specialty services address unique business requirements that go beyond 
                standard IT support, providing customized solutions for specific needs.
              </p>
              
              <div className="space-y-6">
                <div className="bg-itmgmt-light-gray p-6 rounded-lg">
                  <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-3">Specialty Offerings</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Splash Pages & Check-in Wi-Fi</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Custom Desktop Applications</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Employee Onboarding/Offboarding</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>Technology Training & Workshops</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                      <span>IT Documentation & Knowledge Base</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div>
              <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Custom Solutions for Every Business</h2>
              <div className="space-y-6">
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Custom Development</h3>
                    <p className="text-gray-600">
                      Tailored software solutions designed specifically for your business processes.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Training & Education</h3>
                    <p className="text-gray-600">
                      Comprehensive technology training programs for your staff and management.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Process Automation</h3>
                    <p className="text-gray-600">
                      Streamline business processes with automated workflows and systems.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-itmgmt-medium-blue rounded-full h-10 w-10 flex items-center justify-center shrink-0 mr-4">
                    <span className="text-white font-bold">4</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-itmgmt-dark-blue text-lg mb-2">Documentation Services</h3>
                    <p className="text-gray-600">
                      Create comprehensive IT documentation and knowledge bases for your organization.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <ConsultationContactForm />
      <Footer />
    </div>
  );
};

export default SpecialtyServices;
